import { useToast } from "@getbread/dough";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { InvalidJwtApiError } from "../../api-client/authentication";
import type { FCWithChildren } from "../../api-client/resources/types/sharedTypes";
import { useLogout } from "../../utils/useLogout";

const InvalidJwtErrorComponent: React.FC<{ error: unknown }> = ({ error }) => {
	const { logOut } = useLogout();
	const { showToast } = useToast();

	useEffect(() => {
		if (error instanceof InvalidJwtApiError) {
			logOut({ toastId: "sessionExpired" });
		}
	}, [error, showToast, logOut]);

	if (!(error instanceof InvalidJwtApiError)) {
		throw error;
	}
	return null;
};

export const InvalidJwtErrorBoundary: FCWithChildren = ({ children }) => (
	<ErrorBoundary FallbackComponent={InvalidJwtErrorComponent}>{children}</ErrorBoundary>
);
